import React from 'react'
import { Route, Redirect } from 'react-router'
import Loadable from 'react-loadable'
import loading from 'components/ui/Loader/Loader'

const LoadContainer = Loadable({ loader: () => import('layers/bus/containers/LoadContainer/LoadContainer'), loading })
const BusPage = Loadable({ loader: () => import('layers/bus/pages/BusPage/BusPage'), loading })


export default (links) => (
  <Route component={LoadContainer}>
    <Route path={links.root} component={BusPage} />

    <Redirect path={`${links.root}/*`} to={links.root} />
  </Route>
)
